// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DateTimeInput .p-overlaypanel-content {
  padding: 0;
}

.DateTimeInput-op:before,
.DateTimeInput-op::after {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/ui/custom-controls/styles/DateTimeInput.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;;EAEE,aAAa;AACf","sourcesContent":[".DateTimeInput .p-overlaypanel-content {\n  padding: 0;\n}\n\n.DateTimeInput-op:before,\n.DateTimeInput-op::after {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
